<!-- Renders nothing outside a super-context, so callers can include it unconditionally. -->
<mat-accordion class="context-rights" *ngIf="isSuperContext">
  <mat-expansion-panel [expanded]="expanded">

    <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
      <mat-panel-title>
        <mat-icon class="cr-icon">lock_person</mat-icon>
        <span>{{ label }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <p class="cr-empty" *ngIf="loading">{{'loading_ctx' | translate}}</p>
    <p class="cr-empty" *ngIf="!loading && !rows.length">{{'no_subctx' | translate}}</p>

    <ng-container *ngIf="rows.length">

      <input
        class="cr-search"
        type="text"
        placeholder="{{'search' | translate}}…"
        [ngModel]="filterText"
        (ngModelChange)="onFilterChanged($event)" />

      <div class="cr-toolbar">
        <mat-checkbox
          [checked]="allVisibleShared"
          [indeterminate]="someVisibleShared"
          [disabled]="disabled"
          (change)="toggleAllVisible($event.checked)">
          <span class="cr-toolbar-label">
            {{ sharedCount ? (sharedCount +  ('approved' | translate)) : ('share_everyone' | translate) }}
          </span>
        </mat-checkbox>

        <div class="cr-bulk">
          <span class="cr-bulk-hint">{{'focus_on' | translate}}:</span>
          <button mat-icon-button type="button"
            [disabled]="disabled || !sharedVisibleCount"
            matTooltip="{{'set_items_view' | translate}}"
            (click)="applyRight('view')">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [disabled]="disabled || !sharedVisibleCount"
            matTooltip="{{'set_items_shared' | translate}}"
            (click)="applyRight('update')">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>

      <div class="cr-list">
        <p class="cr-empty" *ngIf="!visibleRows.length">{{'no_context_found' | translate}}</p>

        <div class="cr-row" *ngFor="let row of visibleRows; trackBy: trackById"
             [class.cr-row--shared]="row.shared">
          <mat-checkbox
            class="cr-check"
            [checked]="row.shared"
            [disabled]="disabled"
            (change)="toggleShared(row, $event.checked)">
            <span class="cr-name" [matTooltip]="row.name">{{ row.name }}</span>
          </mat-checkbox>

          <!-- The right only applies while the context is on the list. -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cr-right">
            <mat-select
              [value]="row.right"
              [disabled]="disabled || !row.shared"
              (selectionChange)="setRight(row, $event.value)">
              <mat-option *ngFor="let r of RIGHTS" [value]="r.value">
                <mat-icon class="cr-opt-icon">{{ r.icon }}</mat-icon> {{ r.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </ng-container>

  </mat-expansion-panel>
</mat-accordion>
